export let FeedbackRating;
(function (FeedbackRating) {
  FeedbackRating["HAPPY"] = "happy";
  FeedbackRating["NEUTRAL"] = "neutral";
  FeedbackRating["UNHAPPY"] = "unhappy";
})(FeedbackRating || (FeedbackRating = {}));
export const SET_RATING_ACTION = 'setRating';
export const SET_FEEDBACK_ACTION = 'setFeedback';
export const SET_SURVEY_CONTACT_ID_ACTION = 'setSurvey';
export const SET_CONTACT_CONSENT_ACTION = 'setContactConsent';
export const CLOSE_SURVEY_ACTION = 'closeSurvey';
export const INCREMENT_SURVEY_STEP_ACTION = 'incrementSurveyStep';
export const RESET_SURVEY_ACTION = 'resetSurvey';